<template>
    <svg
        fill="currentColor"
        :style="sizeStyle"
        viewBox="0 0 256 256"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M151.273 0L107.636 106.667L140.8 187.734L122.182 213.333C102.517 165.333
               69.8182 85.333 69.8182 85.333L0 256H256L151.273 0Z"
        />
    </svg>
</template>

<script>
    export default {
        name: 'v-icon-valur',
        props: {
            size: {
                default: '1em',
                type: [Number, String],
            },
        },
        computed: {
            sizeStyle() {
                const value = typeof this.size === 'number' ? `${this.size}px` : this.size;
                return { width: value, height: value };
            },
        },
    };
</script>
